import { NextPage } from 'next';
import { GetServerSideProps } from 'next';
import Authors from '@/components/screens/authors/Authors';
import { API_URL, AUTHORS_FOR_PAGE } from '@/helpers/variables';
import { ISearchAuthor } from '@/interfaces/authorsPage.interface';
import { getAlphabet } from '@/helpers/helpers';
import { alphabet } from '@/helpers/variables';

interface IAuthorsLetterProps {
  data: ISearchAuthor;
  letterSign: string;
}

const AuthorsLetter: NextPage<IAuthorsLetterProps> = ({ data, letterSign }) => {
  return <Authors data={data} letterSign={letterSign} />;
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { letterSign } = context.query;
  const isLetterCorrect = Object.keys(alphabet).some((item) => letterSign === item);
  // // Check Fetched Data Error
  if (!isLetterCorrect) {
    return {
      notFound: true,
    };
  }

  const res = await fetch(`${API_URL}satellite/authors/serch-by-first-word/${getAlphabet(String(letterSign))}?page=1&page_size=${AUTHORS_FOR_PAGE}`);
  const data = await res.json();

  return {
    props: {
      data,
      letterSign,
    },
  };
};

export default AuthorsLetter;
